import { render, staticRenderFns } from "./class-voucher.vue?vue&type=template&id=57ef4213&scoped=true"
import script from "./class-voucher.vue?vue&type=script&lang=js"
export * from "./class-voucher.vue?vue&type=script&lang=js"
import style0 from "./class-voucher.vue?vue&type=style&index=0&id=57ef4213&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef4213",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ef4213')) {
      api.createRecord('57ef4213', component.options)
    } else {
      api.reload('57ef4213', component.options)
    }
    module.hot.accept("./class-voucher.vue?vue&type=template&id=57ef4213&scoped=true", function () {
      api.rerender('57ef4213', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/class-voucher.vue"
export default component.exports